import React from 'react'

import { sendDesktopNotification } from './utils'

import './subscriptions.css'

export default class Subscriptions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            subscriptions: JSON.parse(localStorage.getItem("subscriptions")) || [],
            newSubscription: "",
        };

        this.firstRun = true;
    }

    componentDidUpdate(prevProps) {
        // Skip the first run to avoid false positives
        if (this.firstRun) {
            this.firstRun = false;
            return;
        }

        const currentAlerts = this.props.alerts ? this.props.alerts.items : [];
        const previousAlerts = prevProps.alerts ? prevProps.alerts.items : [];
        performCheck(currentAlerts, previousAlerts, this.state.subscriptions, this.props.ignoredServers);
    }

    addSubscription = (e) => {
        e.preventDefault();
        const { subscriptions, newSubscription } = this.state;
        if (newSubscription.length > 0) {
            const updatedSubscriptions = [...subscriptions, newSubscription];
            this.setState({
                subscriptions: updatedSubscriptions,
                newSubscription: "",
            });
            this.saveSubscriptions(updatedSubscriptions);
        }
    }

    removeSubscription = (index, e) => {
        e.preventDefault();
        const { subscriptions } = this.state;
        const updatedSubscriptions = subscriptions.filter((_, i) => i !== index);
        this.setState({
            subscriptions: updatedSubscriptions,
        });
        this.saveSubscriptions(updatedSubscriptions);
    }

    saveSubscriptions = (subscriptions) => {
        localStorage.setItem("subscriptions", JSON.stringify(subscriptions));
    }

    requestPermission = () => {
        Notification.requestPermission()
            .then(permission => {
                if (permission === "denied") {
                    window.alert("Failed to request permission, please enable notifications for this website in your browser settings.");
                }

                this.forceUpdate();
            });
    }

    render() {
        return (
            <div className={`subscriptions-background ${this.props.dialogOpen ? "open" : ""}`}>
                <div className={`subscriptions ${this.props.dialogOpen ? "open" : ""}`}>
                    <h2>
                        Subscriptions
                        <button className="close" onClick={this.props.onClose}><span></span></button>
                    </h2>
                    <p>
                        When an alert that matches one of your subscriptions appears while Heartbeat is not in focus you will receive a desktop notification.
                        <br/><strong>NOTE:</strong> Server filters apply to subscriptions but the service text filter does not.
                    </p>
                    {Notification.permission === "granted" && <p style={{ color: "green" }}>Website has permission to send notifications.</p>}
                    {Notification.permission === "denied" && <p style={{ color: "red" }}>Website does not have permission to send notifications. Please enable notifications for this website in your browser settings.</p>}
                    {Notification.permission === "default" && <p style={{ color: "red", cursor: "pointer" }} onClick={this.requestPermission}>Website does not have permission to send notifications. Click this message to request permission.</p>}
                    {this.state.subscriptions.map((subscription, index) => (
                        <div key={`${index}-${subscription}`} className="subscription">
                            <span><strong>{subscription}</strong></span>
                            <button onClick={(e) => this.removeSubscription(index, e)}>Remove</button>
                        </div>
                    ))}
                    <div>
                        <input type="text" placeholder="Add a subscription" value={this.state.newSubscription} onChange={(e) => this.setState({ newSubscription: e.target.value })} />
                        <button onClick={this.addSubscription}>Add</button>
                    </div>
                </div>
            </div>
        );
    }
}

function performCheck(currentAlerts, previousAlerts, subscriptions, ignoredServers) {
    const newAlerts = getNewAlerts(previousAlerts, currentAlerts);
    
    const matchingSubscriptions = subscriptions.filter((subscription) => {
        return newAlerts.some((alert) => {
            if (ignoredServers.includes(alert.server)) {
                return false;
            }

            return alert.name.includes(subscription);
        });
    });

    if (matchingSubscriptions.length > 0) {
        sendDesktopNotification(`Subscription "${matchingSubscriptions[0]}" has new matching alert.`);
    }
}

function getNewAlerts(previousAlerts, currentAlerts) {
    return (currentAlerts || []).filter((currentAlert) => {
        return !(previousAlerts || []).some((previousAlert) => {
            return currentAlert.name === previousAlert.name;
        });
    });
}


// WEBPACK FOOTER //
// ./src/subscriptions.jsx